import { Divider, Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import globalStyles from './../../../assets/styles/global.module.scss'
import headerStyles from '../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import campaignAnalysisStyles from '../../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignAnalysisStyle.module.scss'
import GlobalPageHeaderText from '../../utility/globalPageHeaderText'
import GlobalButton from '../../utility/globalButton/button'
import AddIcon from '@mui/icons-material/Add';
import { Outlet, useNavigate } from 'react-router-dom'
import { WhatsappCampaignContext, WhatsappCampaignContextPayload } from '../../../context/whatsappCampaignContext'
import { getExecutionColor } from './utils'
import styles from '../../../assets/styles/componentStyles/customApiStyles/customApiStyle.module.scss'
import { hasCampaignManageAccess } from '../../../utils/constants'
import { UserContext, UserContextPayload } from '../../../context/userContext'

const WhatsappCampaignGlobal = () => {

    const { whatsappCampaignListdData, setSelectedWhatsAppCampaign, selectedWhatsAppCampaign, messageTemplateDetail, setMessageTemplateDetail } = useContext(WhatsappCampaignContext) as WhatsappCampaignContextPayload;
    const { apiRoutesPermissionAssignment, userDetail } = useContext(UserContext) as UserContextPayload;

    const navigate = useNavigate();
    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)');
    const flagTabletScreen = useMediaQuery('(max-width : 900px) and (min-width : 600px)');

    const onClickOfNewCampaign = () => {
        setSelectedWhatsAppCampaign(null); 
        setMessageTemplateDetail(null);
        navigate('/whatsappcampaign/createnewcampaign');
    }

    const isDashboardPAge = () => {
        if (window.location.pathname === "/whatsappcampaign/dashboard") {
            return true
        }
        return false
    }
     
    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`}>
                <Grid container sx={{ padding: { xs: "15px 0px", sm: isDashboardPAge() ? "23px 0px" :"18px 0px" } }} direction={"column"} flexWrap={"nowrap"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container sx={{ alignItems: "center" }} direction={"column"}>
                            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.headerTextContainerStyle}`}>
                                <GlobalPageHeaderText
                                    mainHeadText={
                                        <Grid container gap={"10px"} alignItems={"center"}>
                                            {(window.location.pathname === "/" || window.location.pathname === "/whatsappcampaign") 
                                                ? "WhatsApp Campaign" 
                                                    : window.location.pathname === "/whatsappcampaign/dashboard" 
                                                        ? "Dashboard" 
                                                            : !selectedWhatsAppCampaign 
                                                                ? "Create WhatsApp Campaign" 
                                                                    : selectedWhatsAppCampaign.campaign_title
                                            }
                                            {(window.location.pathname == "/whatsappcampaign/createnewcampaign" && selectedWhatsAppCampaign) && 
                                                <Grid item className={`${campaignAnalysisStyles.campaignStatusStyle} ${globalStyles.displayFlex}`} sx={{ boxShadow: `0px 0px 2px ${getExecutionColor(selectedWhatsAppCampaign?.campaign_execution_status_name)}`, backgroundColor: getExecutionColor(selectedWhatsAppCampaign?.campaign_execution_status_name, true) }}>
                                                    <span className={campaignAnalysisStyles.campaignStatusTextStyle} style={{ color: getExecutionColor(selectedWhatsAppCampaign?.campaign_execution_status_name) }}>{selectedWhatsAppCampaign?.campaign_execution_status_name}</span>
                                                </Grid>
                                            }
                                        </Grid>
                                    }
                                    flagMainTextOnly
                                    actionBlock={
                                        !smallScreen &&
                                        <Grid container gap={"12px"} justifyContent={flagTabletScreen ? "start" : "end"} flexWrap={"nowrap"}>
                                            {(window.location.pathname == "/" || window.location.pathname == "/whatsappcampaign") && whatsappCampaignListdData && whatsappCampaignListdData.length > 0 &&
                                                <Grid item>
                                                    {hasCampaignManageAccess(apiRoutesPermissionAssignment, userDetail) && 
                                                        <GlobalButton
                                                            buttonText={"New Campaign"}
                                                            className='primaryButtonStyle'
                                                            startIcon={<AddIcon />}
                                                            sx={{ width: "170px" }}
                                                            onClick={() => onClickOfNewCampaign() }
                                                        />
                                                    }
                                                </Grid>
                                            }
                                        </Grid>
                                    }
                                />
                                {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle} ${styles.customAPIPageDivider}`}/>}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Outlet />
                </Grid>
            </Grid>
        </>
    )
}

export default WhatsappCampaignGlobal
